import HTMLWrapper from './HTMLWrapper';

export default HTMLWrapper;
